import { render, staticRenderFns } from "./MainDetails.vue?vue&type=template&id=0c80521a&"
import script from "./MainDetails.vue?vue&type=script&lang=js&"
export * from "./MainDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports